export default window.$